import { ref } from 'vue'

export function useFileDrop(getFiles: () => File[], onUpdate: (files: File[]) => void, accept: string[] = []) {
  const fileInput = ref<HTMLInputElement | null>(null)

  const addFiles = (fileList: FileList | File[]) => {
    const existing = getFiles()
    const newFiles = Array.from(fileList).filter(
      (f) =>
        (accept.length === 0 || accept.some((ext) => f.name.endsWith(ext))) &&
        !existing.some((e) => e.name === f.name && e.size === f.size),
    )
    onUpdate([...existing, ...newFiles])
  }

  const removeFile = (index: number) => {
    onUpdate(getFiles().filter((_, i) => i !== index))
  }

  const onDrop = (e: DragEvent) => {
    e.preventDefault()
    if (e.dataTransfer?.files) addFiles(e.dataTransfer.files)
  }

  const onFileSelect = (e: Event) => {
    const input = e.target as HTMLInputElement
    if (input.files) addFiles(input.files)
    input.value = ''
  }

  const formatSize = (bytes: number) => {
    if (bytes < 1024) return bytes + ' B'
    return (bytes / 1024).toFixed(0) + ' KB'
  }

  return { fileInput, addFiles, removeFile, onDrop, onFileSelect, formatSize }
}
